import { useEffect, useState, useRef } from "react";
import { ChevronDown, Globe } from "lucide-react";
import { useT } from "../../i18n/LanguageContext";

export default function LanguageToggle({ tone = "light" }) {
  const { lang, setLang, supported } = useT();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const current = supported.find((l) => l.code === lang) || supported[0];
  const baseColor = tone === "light" ? "text-[#faf6ee]" : "text-[#0e1a3f]";
  const hoverBg = tone === "light" ? "hover:bg-white/10" : "hover:bg-[#0e1a3f]/5";

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className={`flex items-center gap-1 sm:gap-1.5 px-2 sm:px-2.5 py-1.5 rounded-full ${baseColor} ${hoverBg} transition text-xs font-semibold uppercase tracking-wider`}
        data-testid="lang-toggle"
        aria-label="Choose language"
      >
        <Globe size={14} className="hidden sm:block" />
        <span className="text-sm">{current.flag}</span>
        <span>{current.label}</span>
        <ChevronDown size={12} className={open ? "rotate-180 transition" : "transition"} />
      </button>
      {open && (
        <div
          className="absolute right-0 mt-2 bg-white rounded-xl shadow-2xl ring-1 ring-[#0e1a3f]/15 overflow-hidden z-50 min-w-[140px]"
          data-testid="lang-menu"
        >
          {supported.map((l) => (
            <button
              key={l.code}
              type="button"
              onClick={() => {
                setLang(l.code);
                setOpen(false);
              }}
              className={`w-full flex items-center gap-3 px-4 py-2.5 text-sm text-[#0e1a3f] hover:bg-[#f3ecdc] transition ${
                lang === l.code ? "bg-[#f3ecdc] font-semibold" : ""
              }`}
              data-testid={`lang-${l.code}`}
            >
              <span className="text-base">{l.flag}</span>
              <span>{l.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
